import { type ForwardedRef, forwardRef } from 'react';

import TooltipV2 from '@/components/Tooltip/TooltipV2';
import { cn } from '@/lib/cn';

export const RoundedButton = forwardRef(
  (
    props: {
      children: React.ReactNode;
      onClick?: () => void;
      className?: string;
      tooltip?: React.ReactNode;
    },
    ref: ForwardedRef<HTMLButtonElement>,
  ) => {
    const { children, onClick, className, tooltip } = props;

    return (
        <button
          className={cn(
          'flex items-center px-2 h-7 rounded-full bg-white hover:bg-muted border transition-all duration-200 text-[13px] font-medium cursor-pointer',
          className,
        )}
        onClick={onClick}
        ref={ref}
      >
        <TooltipV2 tooltipNode={tooltip}>
          <div className="w-full h-full flex items-center justify-center">
            <div className="flex items-center gap-1 px-1">{children}</div>
          </div>
        </TooltipV2>
      </button>
    );
  },
);
